import { Avatar, Box, IconButton, Typography } from '@mui/material'
import { useMenu, useLogout } from '@refinedev/core'
import { NavItemLink, SiderIcon } from '@ds/components'
import Brightness4Icon from '@mui/icons-material/Brightness4'
import Brightness7Icon from '@mui/icons-material/Brightness7'
import LogoutIcon from '@mui/icons-material/Logout'
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined'
import { useContext } from 'react'
import { ColorModeContext } from '@app/contexts/color-mode'
import { ROLES } from '@modules/types'
import { useAuth } from '@app/contexts/auth'

export const Sider = () => {
  const { menuItems, selectedKey } = useMenu()
  const { mutate: logout } = useLogout()
  const { mode, setMode } = useContext(ColorModeContext)
  const { permissions } = useAuth()

  const filteredMenuItems = menuItems.filter(item => {
    if (!permissions || !Array.isArray(permissions)) return true

    if (permissions.length === 1 && permissions.includes(ROLES.ADMIN_PANEL_SHARED_REQUEST_USER)) {
      return item.name === 'share'
    }

    if (
      permissions.includes(ROLES.ADMIN_PANEL_PUBLISHER) ||
      permissions.includes(ROLES.ADMIN_PANEL_COPYRIGHT_MANAGER)
    ) {
      if (item.name === 'share') {
        return false
      }
    }

    return true
  })

  return (
    <Box
      sx={{
        width: 96,
        height: '100vh',
        bgcolor: 'background.default',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Avatar sx={{ width: 56, height: 56, mb: 5, bgcolor: 'text.primary', mt: 4 }}>
          <PersonOutlineOutlinedIcon sx={{ fontSize: 30, color: 'background.paper' }} />
        </Avatar>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            width: '100%',
            gap: 1,
          }}
        >
          {filteredMenuItems.map(({ key, route, icon, label }) => (
            <NavItemLink key={key} to={route || ''} selected={selectedKey === key}>
              <SiderIcon selected={selectedKey === key}>{icon}</SiderIcon>
              <Typography
                sx={{
                  color: 'text.secondary',
                  textAlign: 'center',
                  fontWeight: 500,
                  fontSize: 12,
                  lineHeight: '16px',
                  letterSpacing: 0.5,
                  mt: 0.5,
                }}
              >
                {label}
              </Typography>
            </NavItemLink>
          ))}
        </Box>
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, mb: 5 }}>
        <IconButton onClick={setMode}>
          {mode === 'dark' ? (
            <Brightness7Icon sx={{ color: 'text.primary' }} />
          ) : (
            <Brightness4Icon sx={{ color: 'text.primary' }} />
          )}
        </IconButton>
        <IconButton onClick={() => logout()}>
          <LogoutIcon sx={{ color: 'text.primary' }} />
        </IconButton>
      </Box>
    </Box>
  )
}

export default Sider
